export class VehicleSectionType {
    static ORDER_ACCEPTED = 1;
    static ORDER_DONE = 2;
    static INFO = 3;
    static DOCUMENTS = 4;
}

Object.freeze(VehicleSectionType);